import './index.scss'
import Swiper from 'swiper/dist/js/swiper.min.js'

!(function(){
  $('.header').addClass('black')
})()
// 20230426
let numlist = []
let num = $('.right .swiper .swiper-slide .item-link')//.eq(0).height()
$.each(num,function(index,item){
  numlist.push(item.offsetHeight)
})
let allnum =  Math.max.apply(null, numlist);
$('.right .swiper .swiper-slide .item-link').css({'height': allnum+'px'})
console.log('鏈€缁堥珮搴?,allnum);
var swiper1 = new Swiper(".download-center .swiper1 .swiper", {
  allowTouchMove: false,
  effect : 'fade',
  fadeEffect: {
    crossFade: true,
  },
});
var swiper3 = new Swiper(".download-center .swiper3 .swiper", {
  slidesPerView: 4,
  centeredSlides: true,
  spaceBetween : 30,
  breakpoints: {
    768: {  //褰撳睆骞曞搴﹀皬浜庣瓑浜?68
      slidesPerView: 3,
      spaceBetween: 20,
    }
  }
});
var swiper2 = new Swiper(".download-center .swiper2 .swiper", {
  effect : 'fade',
  fadeEffect: {
    crossFade: true,
  },
  navigation: {
    nextEl: ".download-center .swiper2 .swiper-button-next",
    prevEl: ".download-center .swiper2 .swiper-button-prev",
  },
  on:{
    transitionStart: function(){
      swiper1.slideTo(this.realIndex)
      swiper3.slideTo(this.realIndex)
      swiper4.slideTo(this.realIndex)
    },
  }
});
$('.download-center .swiper3 .swiper .swiper-slide').on('click',function(){
  let index = $(this).index()
  swiper2.slideTo(index)
})

var swiper4 = new Swiper(".download-center .right .swiper", {
  effect : 'fade',
  fadeEffect: {
    crossFade: true,
  },
  allowTouchMove: false,
  autoHeight: true,
  on:{
    init:function(){
        let total = this.slides.length > 9 ? this.slides.length : '0'+this.slides.length
        $('.download-center .right .num-cont .total').html(total)
    },
    transitionStart: function(){
      let activeNum = this.realIndex+1
      activeNum = activeNum > 9 ? activeNum : '0'+ activeNum
      $('.download-center .right .num-cont .active-num').html(activeNum)
    },
  }
});